// Hocs
import asyncRoute from 'routes/AsyncRoute'

// Exports
export function getCheckoutOrderSuppliesComponent({ store }) {
  return new Promise((resolve) => {
    require.ensure(
      [],
      (require) => {
        const View = require('hfty-checkout').CheckoutOrderSupplies
        resolve(View)

        /* Webpack named bundle   */
      },
      'hfty-checkout-order-supplies'
    )
  })
}

export const CheckoutOrderSupplies = asyncRoute({ getComponent: getCheckoutOrderSuppliesComponent, reducers: [] })

export function getCheckoutOrderTestsComponent({ store }) {
  return new Promise((resolve) => {
    require.ensure(
      [],
      (require) => {
        const View = require('hfty-checkout').CheckoutOrderTests
        resolve(View)

        /* Webpack named bundle   */
      },
      'hfty-checkout-order-tests'
    )
  })
}

export const CheckoutOrderTests = asyncRoute({ getComponent: getCheckoutOrderTestsComponent, reducers: [] })
